<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar" /> 查询管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>扫码轮播图</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <!-- 新增按钮 -->
            <el-col :span="8" >
              <el-button
                type="primary"
                @click="add.addshow=!add.addshow , update.show = false"
              >新增</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br id="A1" />
      <!-- 新增修改模块       -->
      <Prodcut-Add :add="add" :search="search" />
      <Prodcut-Update ref="updatechild" :update="update" :search="search" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>产品扩展属性</h4>
          <el-divider />
          <el-table
            id="parent"
            v-loading="listLoading"
            border
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
          >
            <el-table-column
              prop="product_code"
              label="产品编码"
              min-width="100"
              show-overflow-tooltip
            />
            <el-table-column prop="sort" label="排序" min-width="100" show-overflow-tooltip />
            <el-table-column prop="column_title" label="图片说明" min-width="100" show-overflow-tooltip />
            <el-table-column prop="column_value" label="图片地址" min-width="100" show-overflow-tooltip />
            <el-table-column label="操作" min-width="100" fixed="right">
              <template slot-scope="props">
                <el-button-group>
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    @click="getoutbilldata(props.row),update.show =true , add.addshow=false"
                  />
                  <el-button type="danger" icon="el-icon-delete" @click="deletedate(props.row.id)" />
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            :current-page.sync="total_pages"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
            @current-change="currentchange"
            @size-change="pagesize"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  productextendpagelist,
  productextendadd,
  productextendedit,
  productextenddel
} from "@/api/base";
import { departtree } from "@/api/orgin";
import {
  pagewarehouse,
  findwarehouse,
  deletewarehouse,
  updatewarehouse
} from "@/api/query";
import ProdcutAdd from "./components/ProdcutAdd";
import ProdcutUpdate from "./components/ProdcutUpdate";
// 引入导出组件模块
export default {
  name: "Freight",
  components: { ProdcutAdd, ProdcutUpdate },
  data() {
    return {
      // 基础数据
      add: {
        addshow: false
      },
      update: {
        form: {
          id: null,
          product_code: null,
          column_title: null,
          column_value: null,
          status: null,
          sort: null
        },
        show: false
      },
      departtree: [],
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      // 导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      // 分页数据
      pagesizes: "",
      total_count: 1,
      total_pages: 1,
      // 搜索表单数据

      searchform: {
        product_code: "mtytyycommhomeslideshow",
        pageindex: 1,
        pagesize: 10
      }
    };
  },
  mounted() {
    // 请求部门列表数据得到表格
    this.search();
  },
  methods: {
    // 修改按钮
    getoutbilldata(row) {
      document.getElementById("A1").scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth"
      });
      this.update.form = row;
      this.$refs.updatechild.getimg(row.column_value)
    },
    // 请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      productextendpagelist(obj).then(response => {
        console.log(response.data);
        this.tableData = response.data.data;
        this.packdate(this.tableData);
        this.total_count = response.data.total_count;
        this.total_pages = response.data.page_index;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼装表格数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {}
    },
    // 搜索事件
    search() {
      this.Tabledata(this.searchform);
    },
    // 重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 分页跳转事件
    currentchange(pageindex) {
      this.searchform.pageindex = pageindex;
      this.Tabledata({
        product_code: this.searchform.product_code,
        pageindex: this.searchform.pageindex,
        pagesize: this.searchform.pagesize
      });
    },
    // 分页每页显示条数事件
    pagesize(pagesize) {
      this.searchform.pagesize = pagesize;
      this.search();
    },
    // 删除按钮事件
    deletedate(id) {
      console.log(id);
      this.$confirm("此操作将永久删除该产品信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          productextenddel(id).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.search();
            } else {
              this.$message({
                type: "woring",
                message: "删除失败!请检查字段"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
</style>
